// extracted by mini-css-extract-plugin
export default {"Message":"ContactForm_Message__olrS3","Footer":"ContactForm_Footer__EWk7C","Statement":"ContactForm_Statement__9khy8"};